import styled from 'styled-components';

import Checkbox from '../Checkbox';
import Select from '../Select';

export const Container = styled.form`
  display: flex;
  flex-direction: column;

  margin-top: 6px;
`;

export const Info = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: var(--color-gray-400);
  margin-bottom: 6px;
`;

export const CustomCheck = styled(Checkbox)`
  width: 100%;
`;

export const CustomSelect = styled(Select)`
  width: 100%;
`;

export const FieldWrapper = styled.div`
  margin-top: 10px;
  gap: 20px;
`;

export const Divider = styled.div`
  border-bottom: 1px solid var(--color-gray-100);
  margin: 16px 0;
`;
